export default __webpack_public_path__ + "static/media/ecommercebeleza.db483f14.svg";